export default "__VITE_ASSET__B6hhaqew__"